import React from "react";
import useInput from "@ui/lib/hooks/useInput";
import t from "../../../../../i18n";
import type { ClassificationQuantity } from "../../../../../api/useClassificationQuantities";

export const useDescriptionInput = (selectedQuantities: ClassificationQuantity[]) => {
  const hasSameValue = React.useMemo(
    () =>
      selectedQuantities.filter(
        quantity => quantity.description !== selectedQuantities[0]?.description,
      ).length === 0,
    [selectedQuantities],
  );

  const defaultValue = React.useMemo(() => {
    if (hasSameValue) return selectedQuantities[0]?.description ?? "";
    return "";
  }, [hasSameValue, selectedQuantities]);

  const input = useInput(defaultValue);

  const placeholder = React.useMemo(() => {
    if (!hasSameValue) {
      return t("administration.modal.multiple_value");
    }
    if (defaultValue === "") {
      return t("setup.paragraphs.quantities.table.definitions.column.description");
    }
    return defaultValue;
  }, [defaultValue, hasSameValue]);

  return {
    placeholder,
    ...input,
  };
};
